module.exports = __webpack_public_path__ + "plat/static/img/grid.a6b7bff7.svg";